import {CommandesService} from '@/services/CommandesServicePoisson'
import KeyboardService from '@/services/KeyboardService'
import {NotilusService} from '@/services/NotilusService'
import CommonUtils from '@/utils/commonUtils'

export const state = {
  employees: [],
  commandesSettings: []
}

export const mutations = {
  setEmployeesNotilus(state, employees) {
    state.notilus.employees = employees
  },
  setCommandesSettings(state, commandesSettings) {
    state.notilus.commandesSettings = commandesSettings
  }
}

export const actions = {
  getEmployees({commit, rootState, getters}) {
    const clientid = rootState.authentication.userProfile.attributes
    if (clientid) {
      NotilusService.getEmployees(rootState.context.currentContext, getters.contextClientId).then(employees => {
        commit(
          'setEmployeesNotilus',
          employees.map(employee => ({...employee, actif: CommonUtils.toBoolean(employee.actif)}))
        )
      })
    }
  },
  getCommandesSettings({commit, rootState, getters}) {
    const clientid = rootState.authentication.userProfile.attributes
    if (clientid) {
      return Promise.all([
        CommandesService.getAllowedCommandesCode(getters.contextClientId),
        NotilusService.getCommandesSettings(getters.contextClientId)
      ]).then(commandesSettings => {
        const list = commandesSettings[0].map(code => ({...code, text: code.nom}))
        commit('setCommandesSettings', {
          codeList: list,
          limitCode: CommonUtils.toBoolean(commandesSettings[1][0].limitCode),
          shiftCommand: CommonUtils.toBoolean(commandesSettings[1][0].shiftCommand),
          shiftPlateauEmpty: !CommonUtils.toBoolean(commandesSettings[1][0].shiftPlateauEmpty),
          shiftPlateauFrom: !CommonUtils.toBoolean(commandesSettings[1][0].shiftPlateauFrom),
          showLimitCode: CommonUtils.toBoolean(commandesSettings[1][0].showLimitCode),
          minTimeCommandChristmas: commandesSettings[1][0].minTimeCommandChristmas || '08:00',
          minTimeCommandNYE: commandesSettings[1][0].minTimeCommandNYE || '08:00',
          maxTimeCommandChristmas: commandesSettings[1][0].maxTimeCommandChristmas || '20:00',
          maxTimeCommandNYE: commandesSettings[1][0].maxTimeCommandNYE || '20:00',
          montageDefault: commandesSettings[1][0].montageDefault || 0,
          livraisonRule: CommonUtils.toBoolean(commandesSettings[1][0].lieuLivraison),
          onlyTotalPlateauCustom: CommonUtils.toBoolean(commandesSettings[1][0].onlyTotalPlateauCustom),
          commandeNumberLimit: commandesSettings[1][0].commandeNumberLimit || 0
        })
      })
    }
    return ''
  }
}

export default {actions, mutations, state}
